import { render, staticRenderFns } from "./PermissionsApply.vue?vue&type=template&id=e8e3f9ac&scoped=true"
import script from "./PermissionsApply.js?vue&type=script&lang=js&external"
export * from "./PermissionsApply.js?vue&type=script&lang=js&external"
import style0 from "./PermissionsApply.vue?vue&type=style&index=0&id=e8e3f9ac&prod&lang=scss"
import style1 from "./PermissionsApply.scss?vue&type=style&index=1&id=e8e3f9ac&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e3f9ac",
  null
  
)

export default component.exports